import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'

import { getRouterQueryFrom } from '../utils/auth.utils'

const useGetFacebookRedirectURI = (redirectBack?: boolean): string => {
  const router = useRouter()

  const [redirectUri, setRedirectUri] = useState('')
  const from = redirectBack ? router?.asPath : getRouterQueryFrom(router)
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const loginUrl = 'https://www.facebook.com/v21.0/dialog/oauth'
      const redirect_uri = `${window.location.origin}/auth/facebook/callback?utm_nooverride=1`

      const scopes = ['public_profile', 'email']

      const params = new URLSearchParams({
        client_id: process.env.NEXT_PUBLIC_FACEBOOK_APP_ID as string,
        state: from,
        scope: scopes.join(','),
        redirect_uri,
      }).toString()

      setRedirectUri(`${loginUrl}?${params}`)
    }
  }, [from])

  return redirectUri
}

export default useGetFacebookRedirectURI
